export default __webpack_public_path__ + "static/media/hht2_ani_08.21c2d46a.png";